import ClearIcon from "@mui/icons-material/Clear";
import type { IconButtonProps } from "@mui/material/IconButton";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";

import styles from "./Buttons.module.scss";

interface RemoveButtonProps extends IconButtonProps {
  tooltipResourceName?: string;
}

function RemoveButton({
  tooltipResourceName,
  ...iconButtonProps
}: RemoveButtonProps) {
  const t = useTranslation();
  return (
    <IconButton
      {...iconButtonProps}
      className={styles.button}
      size="small"
      title={
        tooltipResourceName
          ? t.removeResource.replace("{resource}", tooltipResourceName)
          : t.remove
      }
    >
      <ClearIcon fontSize="small" />
    </IconButton>
  );
}

const MemoizedRemoveButton = React.memo(RemoveButton);

export { MemoizedRemoveButton as RemoveButton };
